<template>
  <div v-if="yukleme" class="container-fluid">
    <div class="row">
      <div class="col-4 text-right mt-4">
        Arıza ve Planlı Bakımlarda kullanılan malzeme listesi
      </div>
      <div class="col-6 text-right">
        <div class="row mt-3 ml-3">
          <div class="col-4"><input class="form-control" type="date" v-model="d1"></div>
          <div class="col-4"><input class="form-control" type="date" v-model="d2"></div>
          <div class="col-4">
            <button @click="sarapor()" class="btn btn-danger d-block">Rapor Al</button>
          </div>
        </div>
      </div>
      <div class="col-2 text-right"> 
        <span class="dashtext-5" style="font-size:48px"> {{posts.length}}  /  </span>
        <span class="dashtext-3" style="font-size:48px">  {{ekle.length}} </span>
      </div>
    </div>
    <div class="row">
    <div class="col-12">
    <div>
     <table v-if="raporEkran" class="table table-striped">
      <thead>
       <tr>
          <td>#</td>
          <td>Servis No</td>
          <td>Açıklama</td>
       </tr>
      </thead> 
      <tbody>
       <tr v-for="(item,index) in malzemeHata" :key="index">
         <td>{{index+1}}</td>
          <td>{{item.no}}</td>
          <td>Malzeme Listesine Eklenemedi</td>
       </tr>
      </tbody>
     </table>    </div>

     <table v-if="!raporEkran" class="table table-striped">
      <thead>
       <tr>
          <td>#</td>
          <td>Servis No</td>
          <td>Cari</td>
          <td class="text-info">Tip</td>
          <td>Barkod</td>
          <td>Cihaz</td>
          <td class="text-danger">Durum</td>
          <td>Tarih</td>
       </tr>
      </thead> 
      <tbody>
       <tr v-for="(item,index) in ekle" :key="index">
         <td>{{index+1}}</td>
          <td>{{item.no}}</td>
          <td>{{item.cari_ad}}</td>
          <td class="text-info">{{item.st}}</td>
          <td>{{item.barkod}}</td>
          <td>{{item.cname+' '+item.model}}</td>
          <td class="text-danger">{{item.sd}}</td>
          <td>{{$helper.trtgoster(item.tarih)}}</td>
       </tr>
      </tbody>
     </table>
    </div>
    </div>
     <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
export default {
  data() {
    return {
      //servis:[],
      d1:'',
      d2:'',
      posts : [],
      error :[],
      caris:[],
      ekle:[],
      ayar:this.$request.ayar(),
      sa:'',
      bolge:'',
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      yukleme : true, // sağlayıcı mı ?
      donem : this.$request.donem(),
      rapor :{
        ariza:[],
        malzeme:[]
      },
      malzemelik:[],
      malzemeHata:[],
      raporEkran:false
      
    }
  },
  created (){
    // yetki gelecek
     this.sabul(this.bolgebul);

  },
  methods: {
    sarapor(){
      this.raporEkran = true
      this.malzemelik = []
      this.rapor.malzeme =[]
      this.rapor.ariza = []
      if(this.d1 && this.d2){
      this.progres.inprogres = true
      let process = 0;
      this.$request.get('sarapor/'+this.sa+'/'+this.d1+'/'+this.d2)
      .then(res => {
        //console.log(res)
        if (res.results.length ===0) {this.progres.inprogres = false}
        res.results.forEach((element,i) => {
          this.malzemelik.push({no:element.no}) // sipno nun başındaki sıfırlardan kaynaklı this.malzemde geziyoruz
          this.rapor.ariza.push({
           // "id":element.sid,
           // "stid":element.stid,
            "CCI Sipariş Numarası" :parseInt(element.no),
            "Bildirim Metni" : this.servisnotuilk(element.servis_notu),
            "CCI Ekipman Numarası" : element.barkod,
            "Ekipman Model" : element.model,
            "Sticker" : "",
            "Garanti durum":"",
            "CCI Arıza Nedeni":element.sn,
            "İş Yeri tanımı" : "DFS Beverage",
            "Sipariş Veren" : element.cari_kod,
            "Müşteri Açıklama" : element.cari_ad,
            "Adres Verisi 1": element.adres,
            "Adres Verisi 2": element.adres2,
            "Bölge" : element.ilce,
            "Şehir" : element.il,
            "Tel" : element.telefon,
            "Arızanın Açılış Tarihi" : this.$helper.trtgosternoktali(element.ct1),
            "Arızanın Açılış Saati" : element.cs1,
            "Satış geliştirme şefi":"",
            "Alan Satış Müdürü":"",
            "Taşerona iletim Tarihi":this.$helper.trtgosternoktali(element.tarih),
            "Taşerone iletim Saati":element.saat,
            "Satış Telefonu" :element.zm,
            "GPS-X":element.enlem,
            "GPS-Y":element.boylam,
            "Sipariş No":element.no,
            // yeşil alan başlangıç
            "Taşerona Bildirim Kodu":parseInt(element.no),
            "işe Başlama Tarihi" :this.$helper.trtgosternoktali(element.baslangictarih), // func
            "işe Bsl saati":element.baslangicsaat, // func
            "işin Bitiş Tarihi":this.$helper.trtgosternoktali(element.bitistarih), //func
            "işin Bitiş Saati":element.bitissaat, //func
            "Yapılan işin Açıklaması":this.servisnotu(element.iptal,element.stid,element.servis_notu,element.degisim),// servis notu parçalanacak
            "Telefon Görüşmesi Notu":"",
            "Arıza Kodu":this.arizahesap(element.iptal,element.ariza_kodu,element.stid), //arıza kodu parçalanacak
            "Siparişin Durumu":element.durum, // e0010
            "Garanti Kapsamında yapıldı":this.garanti(element.garanti,element.iptal) // gar0 kask
          })
          //console.log(this.rapor.ariza)
          process++
          
          if(process === res.results.length) {
           // alert("ok")
                  // setTimeout(() => {
                //alert(res.results.length +"-"+this.malzemelik.length)
            this.malzeme(this.malzemelik.length);
            //}, 10000);
          }
        });
      })
      .catch(err=>{
        alert(err.message)
      })
      }
      else{
        this.$swal("Girdileri Kontrol Et")
      }
    },
    garanti(gar,ipt){
      if (ipt===1){
        return "BDLZ"
      }
      else{
        return gar
      }

    },
    arizahesap(ipt,kod,st){
      if (ipt===0 && st === 2){let kodu = kod.split("#") 
      return kodu[0]
      }
      else{return ''}
    },
    servisnotuilk(notsu){
      
        let nots = notsu.split("#")
        let notu = nots[0]
        return notu

    },    
    servisnotu(ipt,stid,notsu,deg){
      
        let nots = notsu.split("#")
        let notu = nots[1]
        if (ipt===0 && deg===0){
          switch(stid) {
            case 1:
            return "Planlı Bakım Yapıldı( "+notu+" )"
            break;
            case 2:
            return "Arıza Giderildi( "+notu+" )"
            break;
            case 4:
            return "Montaj Yapıldı( "+notu+" )"
            break;
            case 5:
            return "Demontaj Yapıldı( "+notu+" )"
            break;
          }
      }
      else if (deg===1 && ipt===0){
        return "Değişim Gerekli( "+notu+" )"
      }
      else if (deg===0 && ipt===1){return "iptal edildi( "+notu+" )"}
    },
    malzeme(mlzAdet){
       let toplam = 0
      this.malzemelik.forEach(element => {
//        toplam++ 
          this.$request.get("sarapormalzeme2/"+element.no+"/"+this.sa)
          .then(res => {
            
            this.malzemeEkle(res.results).then(()=>{
              toplam++
                    if(parseInt(mlzAdet) === toplam) {
                      if (this.malzemeHata.length == 0){
        var animalWS = XLSX.utils.json_to_sheet(this.rapor.ariza) 
        var pokemonWS = XLSX.utils.json_to_sheet(this.rapor.malzeme) 
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, animalWS, 'Montaj & Demontaj Listesi') 
        XLSX.utils.book_append_sheet(wb, pokemonWS, 'Malzeme Tüketimi')   
        XLSX.writeFile(wb, Math.floor(Math.random() * 1000000)+'.xls')
        this.progres.inprogres = false
                      }
                      else {
                        this.extratampon()
                      }

      }
            })
            })
          .catch(err=>{
            toplam++
            this.malzemeHata.push({no:element.no})
          })
      })

      //promise bitiş
    },
    extratampon(){
      this.malzemelik = []
      this.malzemelik = this.malzemeHata
      this.malzemeHata = []
      this.malzeme(this.malzemelik.length)
    },
malzemeEkle(arr){
  let cnt = 0
          return new Promise ((resolve) => {
              arr.forEach(record =>{
                this.rapor.malzeme.push({
                  "Sipariş No" : parseInt(record.no),
                  "Ekipman Numarası" : record.barkod,
                  "Malzeme Kodu" :record.stid,
                  Miktar :record.adet,
                  "Malzeme Tanımı":record.isim,
                  "Birim Fiyat" : this.$helper.parabirimi(record.mikrofiyat)
                  })
              cnt++
              
          })
          if (arr.length === cnt) resolve()
          
          })



           //if(process == toplam) {resolve()}

},
    onexport (mlzAdet) {
      this.malzeme(mlzAdet)
      .then(res => {
        var animalWS = XLSX.utils.json_to_sheet(this.rapor.ariza) 
        var pokemonWS = XLSX.utils.json_to_sheet(this.rapor.malzeme) 
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, animalWS, 'Montaj & Demontaj Listesi') 
        XLSX.utils.book_append_sheet(wb, pokemonWS, 'Malzeme Tüketimi')   
        XLSX.writeFile(wb, Math.floor(Math.random() * 1000000)+'.xls')
        this.progres.inprogres = false
      })
      .catch(err => {alert(err)
       this.progres.inprogres = false
      })

    },

   sabul(callback){
     console.log(this.ayar.kid)
      this.$request.get("sabul/"+this.ayar.kid).then(res => {
        console.log(res)
        if (res.status===200) {
            this.sa = res.deger;
            callback(res.deger);
        }
        else{
            this.$swal("Sağlayıcı Değilsiniz");
            this.yukleme = false
          }
       // 
        
      })
      
    },
   bolgebul(sa){
            switch(sa) {
              case 6:
               this.bolge = 5
                break;
              case 5:
               this.bolge = 5
                break;                
              case 7:
                this.bolge = 4
                break;
              case 8:
                this.bolge=6
                break;
            }
    },
   excelExport(event) {
        const arrs = [];
        this.ekle = [];
        var input = event.target;
        var reader = new FileReader();
          reader.onload = (e) => {
            var data = reader.result;
            data = new Uint8Array(data);
            var wb = XLSX.read(data, {type : 'array'});
            var sheet = wb.Sheets[wb.SheetNames[0]]; 
            var range = XLSX.utils.decode_range(sheet['!ref']);
            range.s.c = 0;
            range.e.c = 24;
            range.s.r = 1
            //var range = { s: { c: 0, r: 1 }, e: { c: 24, r: 2 } };//A1:A5
            
            for(var R = range.s.r; R <= range.e.r; ++R) {
              var satir = {}
              for(var C = range.s.c; C <= range.e.c; ++C) {
                /* find the cell object */
                //console.log('Row : ' + R); // satır numarası
                //console.log('Column : ' + C); // kolon numarası
                var cellref = XLSX.utils.encode_cell({c:C, r:R}); //hücre adresi A1 B1
                var column = XLSX.utils.encode_cell({c:C, r:''});

                if(!sheet[cellref]) continue; // if cell doesn't exist, move on
                var cell = sheet[cellref]; // type lar t:s,v:0.633,w:15:17
                //console.log(JSON.stringify({[cellref] : cell.w}));
                Object.assign(satir, {[column]:cell.w}) //es2015
               // Object.assign(satir, {[cellref]:cell.w}) //es2015
              }
              this.posts.push(satir)
              
            }
            //console.log(this.posts)
            this.islem(this.posts,this.servisolustur)
          };
        reader.readAsArrayBuffer(input.files[0]);
        
    },
   islem(arr,callback){callback(arr)},
   servisolustur(element){ //element = this.posts
          for (let i = 0, p = Promise.resolve(); i < element.length; i++) {
              p = p.then(_ => new Promise(resolve => //garantiye almak için cari kontrol deki işlemler sadece 300 ms yi karşılayacak die bişey yok
                setTimeout(() => {
                      this.Kontrol(this.cari,this.cihaz,this.servis,
                        {
                          kodu:element[i]['I1'],
                          alias:element[i]['J1'],
                          fid:this.ayar.firmaid,
                          said:this.sa,
                          enlem:element[i]['X1'],
                          boylam:element[i]['Y1'],
                          ilce:element[i]['M1'],
                          il:element[i]['N1'],
                          adres:element[i]['K1'],
                          adres2:element[i]['L1'],
                          telefon:element[i]['O1'],
                          //cihaz
                          barkod:element[i]['C1'],
                          model:element[i]['D1'],
                          //servis
                          no:element[i]['A1'],
                          st:element[i]['V1'],
                          sn:element[i]['B1'],
                          ct:this.$helper.trtyazdir(element[i]['T1']),
                          cs:element[i]['U1'],
                          ct1:this.$helper.trtyazdir(element[i]['P1']),
                          cs1:element[i]['Q1']

                        }
                        ).then(res => {
                          this.ekle.push(
                            {
                              "no":res.no,
                              "cari_ad":res.cari_ad,
                              "st":res.st,
                              "barkod":res.barkod,
                              "cname":res.cname,
                              "model":res.model,
                              "sd":res.sd,
                              "tarih":res.tarih,
                            }
                          )
                          resolve()
                        })
                    
              
                }, 1000)
               ))
          }
        },
        // yukarıdaki yavaşlatma işlemini aşaüğdaki post işlemine koymak işlemleri daha da hızlandırabilir.(sadece eklenecek kayıtlarda yavaşlar) Denemelisin mutlaka çözdüm :) aşağıda zaten promise dan data dönmesi bekleniyor, sıkıntı olan kısım yukarıdaki hızlı döngü
        Kontrol(cari,cihaz,servis,obj){
          //resolve new json object olacak
          return new Promise((resolve, reject) => {
              cari(obj).then(res =>{
                    let cihazi = {
                      barkod:obj.barkod,
                      model:obj.model,
                      carid:res,
                      cd:4,

                    }
                    //console.log(cihazi)
                    cihaz(cihazi).then(res => {
                      servis(
                        {
                          carid:cihazi.carid,
                          id:res, // cihaz id
                          servisno:obj.no,
                          firma:this.ayar.firmaid,
                          sa:this.sa,
                          bolge:this.bolge, // servise eklenmesi için create de geliyor
                          sn:this.snbul(obj.st), //rastegele gönderdik
                          sd:2,
                          so:2,
                          st:this.stbul(obj.st),
                          // ct:this.$helper.getNow().tarih,
                          // cs:this.$helper.getNow().saat,
                          ct:obj.ct,
                          cs:obj.cs,
                          ct1:obj.ct1,
                          cs1:obj.cs1,
                          //donem:new Date(), // yil ay backend de hesaplanıyor.
                          not:obj.sn
                        }
                      ).then(res =>{
                          resolve(res)
                      })
                })
              })
          })

        },
        stbul(st){
            switch(st) {
              case 'ZM02':
               return 1
                break;
              case 'ZM06':
                return 4
                break;
              case 'ZM07':
                return 5
                break;
              default:
                return 2
            }
        },
        snbul(st){
            switch(st) {
              case 'ZM02':
               return 64
                break;
              case 'ZM06':
                return 67
                break;
              case 'ZM07':
                return 68
                break;
              default:
                return 69
            }
        },
        cari(obj){
          return new Promise ((resolve) =>{
            this.$request.get('carikod/'+this.ayar.firmaid+'/'+obj.kodu)
              .then( res => {
                if(res.results.length===0){this.cariekle(obj).then(res => {resolve(res)})}
               // else{resolve(res.results[0].id)}
               else{this.cariGuncelle(obj)
               .then(
                  resolve(res.results[0].id)
                )}
              })
          })
        },
        cariGuncelle(obj){
          return new Promise((resolve, reject) => {
              let data = {
                kodu:obj.kodu,
                alias:obj.alias,
                fid:obj.fid,
                said:obj.said,
                enlem:obj.enlem,
                boylam:obj.boylam,
                il:obj.il,
                ilce:obj.ilce,
                adres:obj.adres,
                adres2:obj.adres2,
                telefon:obj.telefon
              }
                this.$request.post('cariduzenle/',data).then(res => {
                  resolve(res.id)
                })
           })
        },        

        cariekle(element){
          return new Promise((resolve, reject) => {
            this.$request.post('cari/',element).then(res => {resolve(res.id)})
          })
        },
        cihaz(obj){ // let cihazı geliyor
            return new Promise ((resolve,reject) =>{
                this.$request.get('cihazbarkod/'+this.ayar.firmaid+'/'+obj.barkod)
                .then(res => {
                  if (res.results.length===0){
                    this.cihazekle(obj).then(res => {resolve(res)})
                  }
                  else{
                    let data = {"carid":obj.carid,"id":res.results[0].id,"cd":obj.cd}
                    this.$request.post('cihazCariUpdate',data)
                     .then(
                       resolve(res.results[0].id)
                      )
                  }
                })
            })
        },        
        cihazekle(obj){
          return new Promise ((resolve) =>{
          let datas = {"firma":this.ayar.firmaid,"model":obj.model}
            this.$request.post('cihazmodel/',datas)
            .then(res => {
              if(res.results.length===0){var katid=0}
              else{var katid = res.results[0].id}
              let cihazi = {
                  kat:katid,
                  firma : this.ayar.firmaid,
                  barkod :obj.barkod,
                  durum :4, // must a
                  cid:obj.carid,
                  sa:this.sa,
                 // bolge:parseInt(this.sa + 2) //cihazda bölge olmayacak
              }
             // console.log(cihazi)
                this.$request.post("create/",cihazi)
                .then(res => {
                  resolve(res.data.id)
                })
              })
          })
        },

        servis(obj){
          return new Promise((resolve, reject) => {
            this.servisgetir(obj.servisno)
            .then(response => {
              if (response.results.length===0){
                  this.servisekle(obj)
                   .then(res => {
                     resolve(res.results[0])
                     })
              }
              else{
                this.servisguncelle(obj)
                   .then(res => {
                     resolve(res.results[0])
                    })
              }
            })
          })
        },
        servisekle(obj){
          return new Promise((resolve, reject) => {
            this.$request.post("aktarimservis",obj)
            .then( res => {
              this.servisgetir(obj.servisno)
              .then(res => {
                resolve(res)
              })
            })
          })
        },
        servisguncelle(obj){
          return new Promise((resolve, reject) => {
            this.$request.post("aktarimservisguncelle",obj)
            .then( res => {
              this.servisgetir(obj.servisno)
              .then(res => {
                resolve(res)
              })
            })
          })
        },        
        servisgetir(servisno){
          return new Promise((resolve, reject) => {
            this.$request.get("aktarim/servis/"+this.ayar.ya+"/"+this.ayar.kid+"/"+servisno)
            .then(res => {
                resolve(res)
            })
          })
        }
         
  } //method bitişi
};
</script>
<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputfile + label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
    background-color: red;
}
.inputfile + label {
	cursor: pointer; /* "hand" cursor */
}
</style>




// WEBPACK FOOTER //
// src/views/malzemeRapor.vue